import React from 'react';
import { Link } from 'react-router-dom';

type Props = {
  id: string | number;
  link: string;
  img: string;
  title: string;
  tag: string;
  isCategory?: boolean;
};

const PostVideoLink = (props: Props) => {
  const { img, link, title, tag, isCategory } = props;
  return (
    <Link to={link} className="post-video__link">
      <img src={img} alt="img" className="post-video__img" />
      {(title && (
        <h3
          className="post-video__title"
          dangerouslySetInnerHTML={{ __html: title }}
        ></h3>
      )) ||
        ''}
      {(isCategory && tag && (
        <div className="tag post-video__tag">{tag}</div>
      )) ||
        ''}
    </Link>
  );
};

export default PostVideoLink;
